// extracted by mini-css-extract-plugin
module.exports =  {"root":"_32bbee5fda--root--I0CRz","label":"_32bbee5fda--label--Tojmb"};